import jwtDecode from "jwt-decode";

const TOKEN_KEY = "serviceToken";

let sessionTimeoutId = null;

const clearSessionTimeout = () => {
  if (sessionTimeoutId) {
    window.clearTimeout(sessionTimeoutId);
    sessionTimeoutId = null;
  }
};

const redirectToRoot = () => {
  if (typeof window === "undefined") return;
  window.location.replace("/");
};

const safeDecode = (token) => {
  try {
    return jwtDecode(token);
  } catch (_error) {
    return null;
  }
};

export const verifyAdminToken = (token) => {
  const decoded = safeDecode(token);
  return Boolean(decoded?.exp && decoded.exp * 1000 > Date.now());
};

export const clearAdminSession = () => {
  clearSessionTimeout();
  window.localStorage.removeItem(TOKEN_KEY);
};

export const scheduleAdminSessionTimeout = (token, onExpire) => {
  clearSessionTimeout();

  const decoded = safeDecode(token);
  const expiresAt = decoded?.exp ? decoded.exp * 1000 : 0;

  if (!expiresAt) {
    return;
  }

  const delay = expiresAt - Date.now();

  if (delay <= 0) {
    if (typeof onExpire === "function") {
      onExpire();
      return;
    }
    clearAdminSession();
    redirectToRoot();
    return;
  }

  sessionTimeoutId = window.setTimeout(() => {
    if (typeof onExpire === "function") {
      onExpire();
      return;
    }
    clearAdminSession();
    redirectToRoot();
  }, delay);
};

export const forceAdminSessionTimeout = () => {
  clearAdminSession();
  redirectToRoot();
};
